"use client"

import { Link } from "react-router-dom"
import { Search } from "lucide-react"

const SearchBox = () => {
  return (
    <div className="relative w-full max-w-[368px]">

      {/* ICONO */}
      <div className="absolute left-3 top-1/2 -translate-y-1/2 text-black pointer-events-none max-sm:left-4">
        <Search className="w-4 h-4" />
      </div>

      {/* INPUT dentro de un Link */}
      <Link to="/buscar" className="block">
        <input
          type="text"
          maxLength={80}
          placeholder=" Busca tu dj o sesion favorita"
          className="
            w-full
            rounded-full
            border-0
            bg-white
            text-black
            text-sm
            font-normal
            leading-4
            h-7
            px-10
            outline-none
            placeholder:text-black/50
            truncate

            max-sm:w-[75%]
            max-sm:h-6
            max-sm:px-8
          "
        />
      </Link>

    </div>
  )
}

export default SearchBox
